import React from 'react';
import { RadioGroupInputWUT } from '../../inputs/radio-group-input-wut/radio-group-input-wut';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
import { FieldErrorWUT } from '../field-error/field-error-wut';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { NUMBER_OF_COLUMNS } from '../options-layout/options-layout-constants';
import { Widget } from '../widget/widget';
export const RadioGroupFieldWUT = ({ id, target, label, hideLabel = false, options, description, addOther, addOtherLabel, addOtherPlaceholder, required, value, onChange, onFocus, onBlur, error, hasError = false, errorMessage, disabled = false, otherInputCharacterLimit, FieldLayout, numberOfColumns = NUMBER_OF_COLUMNS.ONE, media, mediaSettings, requiredIndicatorType, requiredIndicatorPlacement, widgetHtml, widgetEnabled })=>{
    const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                media: media,
                mediaSettings: mediaSettings,
                requiredIndicatorType: requiredIndicatorType,
                requiredIndicatorPlacement: requiredIndicatorPlacement
            }),
        renderInput: ()=>widgetHtml && widgetEnabled ? /*#__PURE__*/ React.createElement(Widget, {
                fieldId: id,
                widgetHtml: widgetHtml,
                onChange: onChange,
                value: value
            }) : /*#__PURE__*/ React.createElement(RadioGroupInputWUT, {
                target: target,
                inputId: inputId,
                labelId: labelId,
                hasError: hasError,
                options: options,
                ariaDescribedBy: ariaDescribedBy,
                addOther: addOther,
                addOtherLabel: addOtherLabel,
                addOtherPlaceholder: addOtherPlaceholder,
                required: required,
                value: value,
                onChange: onChange,
                onFocus: onFocus,
                onBlur: onBlur,
                disabled: disabled,
                otherInputCharacterLimit: otherInputCharacterLimit,
                numberOfColumns: numberOfColumns,
                fieldId: id
            }),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FieldErrorWUT, {
                target: target,
                hasError: hasError,
                errorMessage: errorMessage,
                id: errorId
            }), /*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            }))
    });
};

//# sourceMappingURL=radio-group-field-wut.js.map